module.exports = __webpack_public_path__ + "static/img/cabinet24_4.130e68fc.gif";